import React, {useState} from 'react'
import style from '../style/AddItemForm.module.css'


const AddItemForm = (props) => {
    
   const randomItemState = {
        id: 'null', link: "https://www.amazon.de/", name: "HP Pavilion Gaming 15-Inch Micro-EDGE Laptop, Intel Core i5-9300H", description: "Bose QuietComfort 35, Best Noise Cancelling Headphones on the Market", initial_price: 800, current_price: 750, thresshold_price: 750, 
   }

  const [item, setItem] = useState(randomItemState)  

    return(
        <div id={style.addItemForm}>
            <input className={style.trackProductInput} placeholder="Paste the amazon link here" />
            <button className={style.trackProductBtn} onClick={()=> props.addNewItem(item)}>Track Product</button>
        </div>
    )
}

export default AddItemForm